import {priority} from '@priority-software/priority-proto-api/lib/nform';

export const isFormReadOnly = (startRs: priority.netitems.form.IStartRs) => {
    return startRs.Privileges === 2;
};
